GeoJSONLayer = App.loadClass 'grower::handlers/data/GeoJSON_Layer'

class exports.Layer_Planting_Rx_Visualize extends GeoJSONLayer

    constructor: () ->
        super()
        @useSlider = false
        @fetchUrl = 'backend/grower/layers/planting-rx/visualize'


    initSlider: () ->
        @slider = @sidebar_row?.find('.shapefile-slider')

    makeInfoWindow: (ft, layer) ->
        props =
            'ID': ft.properties.display_id
            'Hybrid': ft.properties.hybrid_name
            'Acres': ft.properties.acres
            'Population': ft.properties.population

        if ft.properties.truth_strip
            props['Truth Strip'] = ''

        ft.properties = props

        super(ft, layer)
